<template>
    <nav
        class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row"
    >
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center pt-0">
            <router-link :to="{ name: 'home' }" class="navbar-brand brand-logo">
                <img alt="logo" src="/media/aform-logo-black.png"/>
            </router-link>
            <router-link
                :to="{ name: 'home' }"
                class="navbar-brand brand-logo-mini"
            >
                <img alt="logo" src="/media/aform-logo-black-mini.png"/>
            </router-link>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-stretch">

            <ul class="navbar-nav navbar-nav-right">
                <li class="nav-item nav-logout d-none d-lg-block">
                    <a
                        class="nav-link cursor-pointer"
                        @click="$router.push({ name: 'account.info' })"
                    >
                        <i class="mdi mdi-account"></i>
                    </a>
                </li>

                <!-- Notifications -->
                <dashboard-notification-menu/>

                <li class="nav-item nav-logout  d-lg-block">
                    <a class="nav-link cursor-pointer" @click="logout">
                        <i class="mdi mdi-power"></i>
                    </a>
                </li>
            </ul>

            <button
                class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                data-toggle="offcanvas"
                type="button"
                @click="toggleSidebarOffcanvas"
            >
                <span class="mdi mdi-menu"></span>
            </button>
        </div>
    </nav>
</template>

<script>
import DashboardNotificationMenu from "./DashboardNotificationMenu";

export default {
    name: "DashboardNavbar",
    components: {DashboardNotificationMenu},
    data: () => ({
        search: ""
    }),
    methods: {
        toggleSidebar() {
            let body = document.querySelector("body");
            if (
                body.classList.contains("sidebar-toggle-display") ||
                body.classList.contains("sidebar-absolute")
            ) {
                body.classList.toggle("sidebar-hidden");
            } else {
                body.classList.toggle("sidebar-icon-only");
            }
            console.log("Toggle sidebar clicked");
        },
        searchVideos() {
            if (!this.search.length) return false;
            this.$router.push({
                name: "gym.index",
                params: {q: this.search}
            });
        },
        toggleSidebarOffcanvas() {
            let sidebarOffcanvas = document.querySelector(".sidebar-offcanvas");
            sidebarOffcanvas.classList.toggle("active");
        },
        logout() {
            this.$store.dispatch("logout").then(response => {
                this.$snotify.success("You have been logged out.");
                this.$router.push({name: "login"});
            });
        }
    },
    watch: {
        $route(to, from) {
            let sidebarOffcanvas = document.querySelector(".sidebar-offcanvas");
            sidebarOffcanvas.classList.remove("active");
        }
    }
};
</script>

<style scoped></style>
